import {quoteApiSlice} from 'src/api/v1/quote-ApiSlice';
import {store} from 'src/app/store';

export function convertFromTo(price, fromCurr, toCurr) {
  if (fromCurr !== toCurr) {
    const result = quoteApiSlice.endpoints.getExchangeRates.select()(store.getState());
    const { data, isSuccess, isError, error } = result;
    if (isSuccess) {
      const exchangeRates = data;
      price = price * exchangeRates[fromCurr][toCurr];
    }
  }

  if (toCurr === "huf") {
    price = Math.ceil(price);
  } else {
    price = +(Math.ceil((price * 100).toFixed(6)) / 100).toFixed(2);
  }

  return price;
}
